<template>
	<ul class='anchor-list'>
		<li
			v-for="(service, index) in parsedServices"
			:key="index"
		>
			<a
				:href="service.global_service.url" :target='service.global_service.target' v-html='service.global_service.title'
			>

			</a>
		</li>
		<!-- <li
			v-for="anchor in anchors"
			:key="anchor.id"
			:class="{ current: currentAnchorId === anchor.id }"
		>
			<a
				:href="'#' + anchor.id"
				@click="setCurrentAnchor(anchor.id)"
			>
				{{ anchor.name }}
			</a>
		</li> -->
	</ul>
</template>

<script>
export default {
	data() {
		return {
			anchors: [],
			currentAnchorId: '',
		};
	},
	props: {
		services: {},
	},
	computed: {
		parsedServices() {
			if (this.services) {
				return JSON.parse(this.services);
			} else {
				return null;
			}
		},
	},
	mounted() {
		this.generateAnchors();
		window.addEventListener('hashchange', this.onHashChange);
		this.onHashChange(); // Check the current hash on mount
	},
	beforeDestroy() {
		window.removeEventListener('hashchange', this.onHashChange);
	},
	methods: {
		generateAnchors() {
			const anchorElements = document.querySelectorAll('.anchor');
			this.anchors = Array.from(anchorElements).map((element) => ({
				id: element.id,
				name: element.getAttribute('name'),
			}));
		},
		setCurrentAnchor(id) {
			this.currentAnchorId = id;
		},
		onHashChange() {
			const hash = window.location.hash.slice(1);
			this.currentAnchorId = hash;
		},
	},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.anchor-list {
	list-style: none;
	padding: 0;
  margin-bottom: 24px;

	li {
		color: var(--grey);
    line-height: 24px;

		&:hover {
			font-weight: bold;
			color: var(--duco-blue);
		}

    a {
      text-decoration: none;
    }
	}
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/AnchorList.vue